module.exports = __webpack_public_path__ + "images/marketing/home-burst.png";